/** Shared chart palette aligned with the Visiward accent system. */
export const CHART_COLORS = {
  blue: '#4C6FFF',
  indigo: '#7157FF',
  cyan: '#19C2D1',
  teal: '#21C98B',
  grid: '#21314A',
  axis: '#6B7A94',
  muted: '#91A0B8',
};

export const CATEGORY_SERIES = [
  CHART_COLORS.blue,
  CHART_COLORS.indigo,
  CHART_COLORS.cyan,
  CHART_COLORS.teal,
  '#8FA3C8',
  '#F5A623',
];

export const tooltipStyle = {
  backgroundColor: '#101D31',
  border: '1px solid #21314A',
  borderRadius: 8,
  color: '#F4F7FB',
  fontSize: 12,
};
